import type { IIntegrationsMap } from 'app-core'

/**
 * Whether an integration is switched on for the tenant. Contract-level
 * integrations carry their settings in the map (`{ enabled, ... }`), so the
 * `enabled` flag decides; a bare boolean (older backends) means "contracted".
 */
export function integrationEnabled(integrations: IIntegrationsMap | undefined, name: string): boolean {
    const entry = integrations?.[name]
    return typeof entry === 'object' && entry !== null ? !!entry.enabled : !!entry
}
